module.exports = __webpack_public_path__ + "img/10中国制造网.79da5b71.png";